import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const useResetSession = () => {
  const navigate = useNavigate();

  return (session_id) => {
    if(!Cookies.get('is_call')){
      Cookies.set('chat_session_id', session_id);
      window.location.reload(); // Reload the page to reset the full chat-bot page
    }
  };
}

export default useResetSession;
